import { ContactShadows, Environment } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { Model } from 'algu-domain'
import { useEffect } from 'react'

import { configuratorInterface } from './systems/configurator-interface'
import { getResourceUrl } from './systems/resources'

export const AlguEnvironment = () => {
  const { gl } = useThree()
  const $table = configuratorInterface.useRootEntityState()
  const isCeramic = $table.$top.material === Model.TopMaterial.Ceramic

  useEffect(() => {
    gl.toneMappingExposure = 5
  }, [gl])

  return (
    <>
      <ambientLight intensity={0.1} />
      {isCeramic ? <directionalLight position={[0, 8, 0]} intensity={0.4} /> : null}
      <Environment files={getResourceUrl('/environments/satara_night_no_lamps_1k.hdr')} />

      <ContactShadows
        position={[0, -400, 0]}
        opacity={0.15}
        width={3000}
        height={3000}
        blur={0.9}
        near={100}
        far={45000}
      />
    </>
  )
}
